export default __webpack_public_path__ + "static/media/copyLinkPrimary.f89bb3e0.svg";